// extracted by mini-css-extract-plugin
export default {"authList":"AuthNav_authList__YGzy7","authItem":"AuthNav_authItem__23RaG"};